import React from "react";

const SearchIcon = () => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.9778 26L14.8778 16.9C14.1556 17.4778 13.325 17.9352 12.3861 18.2722C11.4472 18.6093 10.4481 18.7778 9.38889 18.7778C6.76482 18.7778 4.54422 17.8687 2.72711 16.0507C0.91 14.2326 0.000963727 12.012 7.64256e-07 9.38889C-0.000962199 6.76578 0.908075 4.54519 2.72711 2.72711C4.54615 0.909037 6.76674 0 9.38889 0C12.011 0 14.2321 0.909037 16.0521 2.72711C17.8721 4.54519 18.7807 6.76578 18.7778 9.38889C18.7778 10.4481 18.6093 11.4472 18.2722 12.3861C17.9352 13.325 17.4778 14.1556 16.9 14.8778L26 23.9778L23.9778 26ZM9.38889 15.8889C11.1944 15.8889 12.7294 15.2572 13.9938 13.9938C15.2581 12.7304 15.8899 11.1954 15.8889 9.38889C15.8879 7.58237 15.2562 6.04789 13.9938 4.78544C12.7313 3.523 11.1964 2.89081 9.38889 2.88889C7.58141 2.88696 6.04693 3.51915 4.78545 4.78544C3.52396 6.05174 2.89178 7.58622 2.88889 9.38889C2.886 11.1916 3.51819 12.7265 4.78545 13.9938C6.0527 15.261 7.58719 15.8927 9.38889 15.8889Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default SearchIcon;
